import { Box, Button, OutlinedInput, Stack } from "@mui/material";
import { useFormik } from "formik";
import React, { forwardRef, useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import classes from "../CorreoElectronico.module.css";
import {
  UPDATE_EMAIL_STEP,
  useStepsContext,
} from "../../../../contexts/steps-controller";
import { requestFactura } from "../../../../controllers/order";
import { emailValidationSchema } from "../../../../models/yupModels";
import Theme from "../../../../constants/Theme";

const FormCorreoElectronico = forwardRef(function FormCorreoElectronico(
  { nextStep, showToast, prevStep, isActive, ...props },
  ref
) {
  const [isDisabled, setIsDisabled] = useState(false);
  const { formStepsState, formStepsController } = useStepsContext();

  const _handleRequestFactura = (formStepsState, email) => {
    //Deshabilitamos el botón hasta que termine la petición
    setIsDisabled(true);

    const { folioStep, datosClienteStep } = formStepsState;
    requestFactura({
      ...datosClienteStep,
      folio: folioStep.folio,
      correoCliente: email,
      monto: folioStep.monto,
      origen: folioStep.origen
    })
      .then((response) => {
        setTimeout(() => {
          nextStep();
        }, 50);
      })
      .catch((err) => {
        // Si es error de tipo 400, mostramos el error del Api, si no, regresamos error genérico
        let message =
          err.status >= 400 && err.status < 500
            ? err.data
            : "Ocurrió un error inesperado";
        showToast({
          type: "error",
          message,
        });
        console.log("ERROR DEL API", err);
      })
      .finally(() => {
        setIsDisabled(false);
      });
  };

  //Detecta cuando se esta reiniciando el form, es decir está en la primer pantalla
  useEffect(() => {
    if (isActive === 1) {
      formik.resetForm();
    }
  }, [isActive]);

  const formik = useFormik({
    initialValues: formStepsState.emailStep,
    validationSchema: emailValidationSchema,
    onSubmit: (props) => {
      formStepsController({ type: UPDATE_EMAIL_STEP, props });
      // Mandamos el email del formik porque por alguna razón tarda en guardar el email en el controller
      _handleRequestFactura(formStepsState, props.email);
    },
  });

  return (
    <>
      <Box ref={ref} sx={{ display: "flex", flexDirection: "column" }}>
        <Box
          className={classes.formEmail}
          sx={{
            display: "flex",
            justifyContent: "center",
            p: 1,
            flex: "1 0",
            flexDirection: "column",
            borderRadius: 1,
          }}
        >
          <h2>Ingresa tu correo electrónico para continuar</h2>
          {/* Primera sección */}
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <lottie-player
              src="https://assets4.lottiefiles.com/packages/lf20_sbjonge4.json"
              mode="bounce"
              background="rgba(255, 255, 255, 0)"
              speed="1"
              style={{ width: 250, height: 200 }}
              autoplay
              loop
            ></lottie-player>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                // padding: "8px 30px 8px 8px",
                flex: "1 0",
                flexDirection: "column",
                borderRadius: 1,
              }}
              key="inputMonto"
            >
              <OutlinedInput
                placeholder="Correo Electrónico"
                style={{ marginTop: "20px" }}
                onChange={formik.handleChange("email")}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                value={formik.values.email}
                error={formik.errors.email && formik.touched.email}
                autoComplete="new-password"
              />
              <p
                style={
                  formik.errors.email && formik.touched.email
                    ? { color: Theme.COLORS.ERROR }
                    : {}
                }
                className="helperText"
                key="helperTextEmail"
              >
                {formik.errors.email && formik.touched.email
                  ? formik.errors.email
                  : "Ingresa tu correo electrónico"}
              </p>
            </Box>
          </Stack>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            p: 1,
            marginY: 2,
            borderRadius: 1,
            width: "100%",
          }}
        >
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button
              onClick={() => {
                setTimeout(() => {
                  prevStep();
                }, 300);
              }}
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              className={classes.backButton}
              style={{ color: Theme.COLORS.LIGHT_GRAY }}
            >
              Volver
            </Button>
            <Button
              variant="contained"
              className="buttonNext"
              disabled={isDisabled}
              onClick={() => formik.setFieldValue("email", formik.values.email.trim(), true).then(() => formik.handleSubmit())}
              style={{
                backgroundColor: !isDisabled
                  ? Theme.COLORS.PRIMARY
                  : Theme.COLORS.LIGHT_GRAY,
                  fontFamily: 'Montserrat, Arial, sans-serif'
              }}
            >
              {!isDisabled ? "Siguiente paso" : "Cargando"}
            </Button>
          </Stack>
        </Box>
      </Box>
    </>
  );
});

export default FormCorreoElectronico;
